import React from "react";
import UserManagement from "./UserManagement";

const UserManagementPage = () => {
  return <UserManagement />;
};

export default UserManagementPage;

